module.exports = __webpack_public_path__ + "static/media/Upload_Image.22861f2d.svg";